import React from 'react';
import { RankingsStatsSection as RankingsStatsSectionImpl } from './stats.sections';

export default function RankingsStatsSection(props) {
    return <RankingsStatsSectionImpl {...props} />;
}
